import { config } from 'config';
import type { Placement, Series } from './types';

const base = config.apiBaseUrl;

function getJson<T>(res: Response): Promise<T> {
  if (!res.ok) {
    return res.json().then(
      (body: { message?: string; code?: string }) => {
        throw new Error(body.message ?? `HTTP ${res.status}`);
      },
      () => {
        throw new Error(`HTTP ${res.status}`);
      }
    );
  }
  return res.json();
}

export async function searchSeries(query: string, limit?: number): Promise<Series[]> {
  const search = new URLSearchParams();
  search.set('q', query);
  if (limit != null) search.set('limit', String(limit));
  const res = await fetch(`${base}/series/search?${search.toString()}`, { credentials: 'include' });
  return getJson<Series[]>(res);
}

export async function createSeries(name: string): Promise<Series> {
  const res = await fetch(`${base}/series`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({ name }),
  });
  return getJson<Series>(res);
}

export interface SeriesWithStats extends Series {
  stats: Record<Placement, number>;
}

export interface ListSeriesWithStatsResponse {
  items: SeriesWithStats[];
  total: number;
  page: number;
  limit: number;
}

export async function getSeriesWithStats(params?: {
  page?: number;
  limit?: number;
}): Promise<ListSeriesWithStatsResponse> {
  const search = new URLSearchParams();
  if (params?.page != null) search.set('page', String(params.page));
  if (params?.limit != null) search.set('limit', String(params.limit));
  const query = search.toString();
  const url = query ? `${base}/series/with-stats?${query}` : `${base}/series/with-stats`;
  const res = await fetch(url, { credentials: 'include' });
  return getJson<ListSeriesWithStatsResponse>(res);
}
